<script lang="ts" setup>
import InputText from 'primevue/inputtext'
import { ref } from 'vue'
import { Icon } from '@iconify/vue'

const emit = defineEmits(['update:searchQuery'])
const searchQuery = ref('')

const onInput = () => {
  emit('update:searchQuery', searchQuery.value)
}
</script>

<template>
  <span class="relative">
    <Icon
      icon="majesticons:search"
      class="absolute top-2/4 -mt-3 left-3 text-neutral-500 text-[22px]"
    />
    <InputText
      v-model="searchQuery"
      @input="onInput"
      placeholder="Search "
      class="pl-10 w-96 text-[15px]"
    />
  </span>
</template>

<style></style>
